<script>
import { ref } from "@vue/composition-api";
import AddressService from "@/services/AddressService";

export default {
  name: "SelectAddressModal",

  props: {
    value: {
      required: true,
      type: Boolean
    },
    userId: {
      required: true,
      type: Number
    }
  },

  setup() {
    const addressList = ref([]);
    const addressListLoading = ref(false);

    return {
      addressList,
      addressListLoading
    };
  },

  methods: {
    getUserAddresses(userId) {
      this.addressListLoading = true;
      AddressService.userAddressList(userId).then(({ status, data, message }) => {
        if (status === 200) {
          this.addressList = data;
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.addressListLoading = false;
      }).catch(() => {
        this.addressListLoading = false;
      });
    },

    selectAddress(address) {
      this.$emit("select", address);
    }
  },

  watch: {
    userId: {
      handler() {
        this.getUserAddresses(this.userId);
      },
      immediate: true
    }
  }
};
</script>

<template>

  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400px">
    <v-card color="grey lighten-5" class="pb-1">
      <v-card-title class="align-center">
        <div>
          Adres Seçimi
        </div>
        <v-spacer />
        <div>
          <v-btn icon @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5 pb-2">
        <div v-if="addressListLoading" class="d-flex flex-column align-center py-10">
          <v-progress-circular
            size="100"
            indeterminate
            color="primary"
            class="mb-2"
          ></v-progress-circular>
          <div class="text-body-1 font-weight-medium">
            Adres Bilgileri Yükleniyor
          </div>
        </div>
        <div v-else>
          <v-card
            v-ripple
            :key="key"
            v-for="(address, key) in addressList.list"
            class="mb-2"
            @click="selectAddress(address)"
          >
            <v-card-text>
              <span class="text-body-1 mb-1 font-weight-medium d-block">{{ address.name }}</span>
              <div class="text-body-2 mb-1">Ad Soyad: {{ address.namesurname }}</div>
              <span class="text-grey-8">Mahalle:</span>
              {{ address.neighbourhood }}
              <br />
              <span class="text-grey-8">Adres:</span>
              {{ address.address }}
              <span v-show="address.postcode">- {{ address.postcode }},</span>
              {{ address.district }}/{{ address.city }}
              <br />
              <span class="text-grey-8">Gsm:</span>
              {{ address.telephone }}
              <br />
              <br />
              <span class="text-grey-8">Fatura Türü:</span>
              {{ address.type === 1 ? "Bireysel" : "Kurumsal" }}
              <br />
              <span v-if="address.type === 1">
                      <span class="text-grey-8">T.C.:</span>
                      {{ address.citizenshipnumber }}
                    </span>
              <span v-else>
                      <span class="text-grey-8">Firma Adı:</span>
                      {{ address.companyname }}
                      <br />
                      <span class="text-grey-8">Vergi Numarası:</span>
                      {{ address.taxnumber }}
                      <br />
                      <span class="text-grey-8">Vergi Dairesi:</span>
                      {{ address.taxoffice }}
                    </span>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn small color="red" dark @click="$emit('input', false)">
          <v-icon size="1.25rem" class="mr-1">mdi-close</v-icon>
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>